import type { RecommendedVehicle } from '~/contracts/common';
import type { Vehicle } from '~/contracts/srp';
import { isDefined } from './array';

const TWO_HOURS = 7200;

export default function getPurchaseStatus(
  vehicle: Partial<Vehicle | RecommendedVehicle>
) {
  if (!isDefined(vehicle.vehicleUnlockDateTime)) {
    return {
      isLocked: false,
      isOnHold: false
    };
  }

  const timeLeft = Date.parse(vehicle.vehicleUnlockDateTime) - Date.now();

  // in case the unlock time is in the past
  if (timeLeft < 0) {
    return {
      isLocked: false,
      isOnHold: false
    };
  }

  return {
    isLocked: Math.floor(timeLeft / 1000) >= TWO_HOURS,
    isOnHold: Math.floor(timeLeft / 1000) < TWO_HOURS
  };
}
